(function () {
    'use strict';

    angular
        .module('app.associationAdmin')
        .component('sc3AssociationReports', {
            templateUrl: 'app/association-admin/association-reports/association-reports.component.html',
            controller: AssociationReportsComponent,
            bindings: {
                reports: '<',
                managementGroups: '<'
            }
        });

    var noop = angular.noop,
        identity = angular.identity;

    AssociationReportsComponent.$inject = ['$http', 'alert', 'associationAdminResources'];
    function AssociationReportsComponent($http, alert, resources) {
        var ctrl = this;
        ctrl.associationId = null;        
        ctrl.openReport = openReport;
        ctrl.$onInit = init;

        /////////////////////

        function init() {
            var group = ctrl.managementGroups[0] || {};
            ctrl.associationId = group.associationId;
            ctrl.managementGroupId = group.id;
        }

        function openReport(report) {
            $http.get(report.url, { params: { AssociationId: ctrl.associationId, ClubManagementGroup: ctrl.managementGroupId }, cache: true, showLoading: true }).then(success, error);

            function success(response) {
                var wnd = window.open();
                wnd.document.write(response.data);
                wnd.document.title = report.name;
                wnd.$initialize = initialize;
                wnd.document.close();
            }
            function error() {
                alert.error(resources.reportRetrievalFailed);
            }

            function initialize($) {
                $.ajaxTransport("+*", transform);

                function transform(options) {
                    return { send: send, abort: noop };

                    function send(_, callback) {
                        $http.get(options.url, { transformResponse: identity }).then(process, process);
                        function process(response) {
                            var contentType = response.headers('Content-Type');
                            callback(response.status, response.statusText, { text: response.data }, "Content-Type: " + contentType);
                        }
                    }
                }
            }
        }
    }
})();